var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-card",
    {
      attrs: { elevation: "0" },
      on: {
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.handleDragOver($event)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.handleDragLeave($event)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.handleFileDrop($event)
        },
        dragend: function ($event) {
          $event.preventDefault()
          return _vm.handleDragLeave($event)
        },
      },
    },
    [
      _c(
        "v-card-title",
        { staticClass: "px-4 py-2" },
        [
          _vm._v(" Activity "),
          _c(
            "v-btn",
            { attrs: { icon: "" }, on: { click: _vm.loadCommunications } },
            [
              _c("v-icon", { attrs: { small: "" } }, [
                _vm._v("fas fa-sync-alt"),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _c("v-divider"),
      _c(
        "v-card-text",
        {
          directives: [
            {
              name: "scroll",
              rawName: "v-scroll.self",
              value: _vm.onScroll,
              expression: "onScroll",
              modifiers: { self: true },
            },
          ],
          staticClass: "mb-2 pa-0",
          style: `height:calc(100vh - 353px - ${_vm.app.bottom_height}px);overflow:auto; scrollbar-color: red yellow;`,
          attrs: { id: "messages" },
        },
        [
          _vm.loading
            ? _c("v-progress-linear", { attrs: { indeterminate: "" } })
            : _vm._e(),
          _c(
            "div",
            { staticClass: "pa-2" },
            [
              _c("messages", {
                attrs: {
                  messages: _vm.messages,
                  phone_number: _vm.phone_number,
                },
                on: { getMoreMessages: _vm.getMoreMessages },
              }),
            ],
            1
          ),
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500" },
              model: {
                value: _vm.show_file_upload,
                callback: function ($$v) {
                  _vm.show_file_upload = $$v
                },
                expression: "show_file_upload",
              },
            },
            [
              _c(
                "v-card",
                [
                  _c(
                    "v-card-title",
                    { staticClass: "text-h5 primary" },
                    [
                      _vm._v(" Send Images "),
                      _c("v-spacer"),
                      _c(
                        "v-btn",
                        {
                          attrs: { icon: "" },
                          on: {
                            click: function ($event) {
                              _vm.files = []
                              _vm.show_file_upload = false
                            },
                          },
                        },
                        [_c("v-icon", [_vm._v("mdi-close")])],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("v-divider"),
                  _c(
                    "v-card-text",
                    {
                      staticClass: "py-4",
                      on: {
                        dragover: function ($event) {
                          $event.preventDefault()
                          return _vm.handleDragOver($event)
                        },
                        dragleave: function ($event) {
                          $event.preventDefault()
                          return _vm.handleDragLeave($event)
                        },
                        drop: function ($event) {
                          $event.preventDefault()
                          return _vm.handleFileDrop($event)
                        },
                        dragend: function ($event) {
                          $event.preventDefault()
                          return _vm.handleDragLeave($event)
                        },
                      },
                    },
                    [
                      _vm.files.length > 0
                        ? _c(
                            "div",
                            _vm._l(_vm.files, function (file, index) {
                              return _c(
                                "span",
                                { key: index },
                                [
                                  _c("v-hover", {
                                    scopedSlots: _vm._u(
                                      [
                                        {
                                          key: "default",
                                          fn: function ({ hover }) {
                                            return [
                                              _c(
                                                "span",
                                                [
                                                  _vm.isImage(file)
                                                    ? _c(
                                                        "v-img",
                                                        {
                                                          staticClass:
                                                            "ma-1 rounded upload-preview-image white float-left",
                                                          attrs: {
                                                            src: _vm.previewSrc(
                                                              file
                                                            ),
                                                            "aspect-ratio": 1,
                                                            alt: "preview image",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-overlay",
                                                            {
                                                              attrs: {
                                                                absolute: true,
                                                                value: hover,
                                                                opacity: "0.8",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    "x-small":
                                                                      "",
                                                                    icon: "",
                                                                    outlined:
                                                                      "",
                                                                  },
                                                                  on: {
                                                                    click:
                                                                      function (
                                                                        $event
                                                                      ) {
                                                                        return _vm.removeImage(
                                                                          index
                                                                        )
                                                                      },
                                                                  },
                                                                },
                                                                [
                                                                  _c("v-icon", [
                                                                    _vm._v(
                                                                      "mdi-close"
                                                                    ),
                                                                  ]),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      )
                                                    : _c(
                                                        "v-responsive",
                                                        {
                                                          staticClass:
                                                            "ma-1 primary rounded upload-preview-image float-left",
                                                          attrs: {
                                                            "aspect-ratio": 1,
                                                            alt: "preview pdf",
                                                          },
                                                        },
                                                        [
                                                          _c(
                                                            "v-row",
                                                            {
                                                              staticStyle: {
                                                                height: "100%",
                                                              },
                                                              attrs: {
                                                                align: "center",
                                                                justify:
                                                                  "center",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "v-col",
                                                                {
                                                                  staticClass:
                                                                    "text-center",
                                                                },
                                                                [
                                                                  file.type.indexOf(
                                                                    "pdf"
                                                                  ) > 0
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mt-6",
                                                                          attrs:
                                                                            {
                                                                              "x-large":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-file-pdf-box"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _vm._e(),
                                                                  file.type.indexOf(
                                                                    "audio"
                                                                  ) > -1
                                                                    ? _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mt-6",
                                                                          attrs:
                                                                            {
                                                                              "x-large":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-volume-high"
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "v-icon",
                                                                        {
                                                                          staticClass:
                                                                            "mt-6",
                                                                          attrs:
                                                                            {
                                                                              "x-large":
                                                                                "",
                                                                            },
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "mdi-file"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                  _c(
                                                                    "v-overlay",
                                                                    {
                                                                      attrs: {
                                                                        absolute: true,
                                                                        value:
                                                                          hover,
                                                                        opacity:
                                                                          "0.8",
                                                                      },
                                                                    },
                                                                    [
                                                                      _c(
                                                                        "v-btn",
                                                                        {
                                                                          attrs:
                                                                            {
                                                                              "x-small":
                                                                                "",
                                                                              icon: "",
                                                                              outlined:
                                                                                "",
                                                                            },
                                                                          on: {
                                                                            click:
                                                                              function (
                                                                                $event
                                                                              ) {
                                                                                return _vm.removeImage(
                                                                                  index
                                                                                )
                                                                              },
                                                                          },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "v-icon",
                                                                            [
                                                                              _vm._v(
                                                                                "mdi-close"
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ],
                                                                        1
                                                                      ),
                                                                    ],
                                                                    1
                                                                  ),
                                                                ],
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          ),
                                                        ],
                                                        1
                                                      ),
                                                ],
                                                1
                                              ),
                                            ]
                                          },
                                        },
                                      ],
                                      null,
                                      true
                                    ),
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          )
                        : _c(
                            "v-row",
                            {
                              staticClass: "text-center",
                              staticStyle: { "min-height": "145px" },
                              attrs: { align: "center", justify: "center" },
                            },
                            [
                              _c("v-col", [
                                _vm._v(" Drop Files Here or "),
                                _c("a", { on: { click: _vm.openFiles } }, [
                                  _vm._v("click here"),
                                ]),
                                _vm._v(" to select "),
                              ]),
                            ],
                            1
                          ),
                      _c(
                        "v-overlay",
                        {
                          attrs: {
                            absolute: true,
                            value: _vm.highlight_file_drop,
                            color: "success",
                          },
                        },
                        [_vm._v(" DROP FILES HERE ")]
                      ),
                      _c("div", { staticStyle: { clear: "both" } }),
                    ],
                    1
                  ),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-textarea", {
                        staticClass: "mt-4",
                        attrs: {
                          "hide-details": "auto",
                          outlined: "",
                          label:
                            _vm.app.phone_number_input &&
                            _vm.app.phone_number_input.length >= 10
                              ? `Message to ` +
                                _vm.app.phoneNumberFormat(
                                  _vm.app.phone_number_input
                                )
                              : "",
                          "append-icon": "fas fa-paper-plane",
                          rows: "1",
                          "auto-grow": "",
                          messages:
                            "Shift+Enter for a new line. ENTER to send.",
                          loading: _vm.uploading_files,
                        },
                        on: {
                          "click:append": _vm.sendMessageWithImages,
                          keydown: _vm.imageMessageKeydown,
                        },
                        scopedSlots: _vm._u([
                          {
                            key: "prepend",
                            fn: function () {
                              return [
                                _c(
                                  "v-btn",
                                  {
                                    attrs: { icon: "" },
                                    on: { click: _vm.openFiles },
                                  },
                                  [_c("v-icon", [_vm._v("mdi-paperclip")])],
                                  1
                                ),
                              ]
                            },
                            proxy: true,
                          },
                        ]),
                        model: {
                          value: _vm.message_text,
                          callback: function ($$v) {
                            _vm.message_text = $$v
                          },
                          expression: "message_text",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "v-card-actions",
        [
          _c("v-textarea", {
            attrs: {
              "hide-details": "auto",
              outlined: "",
              label:
                _vm.app.phone_number_input &&
                _vm.app.phone_number_input.length >= 10
                  ? `Message to ` +
                    _vm.app.phoneNumberFormat(_vm.app.phone_number_input)
                  : "",
              "append-icon": "fas fa-paper-plane",
              rows: "1",
              "auto-grow": "",
              messages: "Shift+Enter for a new line. ENTER to send.",
              loading: _vm.sending_message,
            },
            on: {
              "click:append": _vm.sendMessage,
              keydown: _vm.messageKeydown,
            },
            scopedSlots: _vm._u([
              {
                key: "prepend",
                fn: function () {
                  return [
                    _c(
                      "v-btn",
                      {
                        attrs: { icon: "" },
                        on: {
                          click: function ($event) {
                            _vm.show_file_upload = true
                          },
                        },
                      },
                      [_c("v-icon", [_vm._v("mdi-paperclip")])],
                      1
                    ),
                  ]
                },
                proxy: true,
              },
            ]),
            model: {
              value: _vm.message_text,
              callback: function ($$v) {
                _vm.message_text = $$v
              },
              expression: "message_text",
            },
          }),
        ],
        1
      ),
      _c(
        "v-overlay",
        {
          attrs: {
            absolute: true,
            value: _vm.highlight_file_drop,
            color: "success",
          },
        },
        [_vm._v(" DROP FILES HERE ")]
      ),
      _c("div", { staticStyle: { display: "none" } }, [
        _c("input", {
          attrs: {
            type: "file",
            name: "",
            id: "input_file",
            hidden: "",
            multiple: "",
            accept: _vm.accepted_file_types.join(","),
          },
          on: { change: _vm.handleSelectedFiles },
        }),
        _c("button", { attrs: { onclick: "open_file()" } }),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }